import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';
import ModelState from './_util/model';

class VouchersCreateState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/vouchers'; }
}

class VoucherGetState extends ModelState {
  sanitizeModelId(id) { return parseFloat(id); }

  get url() { return '/vouchers'; }
  get singular() { return 'voucher'; }
  get plural() { return 'vouchers'; }
}

class VouchersState {
  @lazyInitialize @nonenumerable voucherGet = new VoucherGetState(this.ctx);
  @lazyInitialize @nonenumerable voucherCreate = new VouchersCreateState(this.ctx);

  @nonenumerable
  listeners = [];

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default VouchersState;



// WEBPACK FOOTER //
// ./spa/state/vouchers.jsx